(function (doc, win) {
    // var isMobile = /mobile/i.test(navigator.userAgent);
    // if (!isMobile) return;
    const docEl = doc.documentElement
    const recalc = function () {
        let clientWidth = docEl.clientWidth
        // 判断是否横屏
        const isHorizontal = window.orientation === 90 || window.orientation === -90
        const maxWidth = isHorizontal ? 1334 : 750
        clientWidth = clientWidth > maxWidth ? maxWidth : clientWidth

        // webview 显示器窗口
        const devWidth = maxWidth // parseFloat(document.getElementsByTagName('html')[0].getAttribute('data-width'))||634;
        if (!clientWidth) return
        const fz = 100 * clientWidth / devWidth
        docEl.style.fontSize = fz + 'px'
        // 修复界面文字大小系统设置字体大小影响问题
        const realfz = parseFloat(win.getComputedStyle(doc.getElementsByTagName('html')[0]).fontSize)
        if (fz !== realfz) {
            docEl.style.fontSize = fz * (fz / realfz) + 'px'
        }
    }
    if (!doc.addEventListener) return
    // var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    // win.addEventListener(resizeEvt, recalc, false);
    // recalc();
    doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
